import { Grid2 as Grid, Skeleton, Box, Typography } from '@mui/material'

interface TitleProps {
  title: string
}

const Title: React.FC<TitleProps> = ({ title }) => (
  <Grid size={12}>
    <Typography variant='h6'>{title}</Typography>
  </Grid>
)

const FAQSkeleton = () => (
  <Grid container size={12} spacing={3}>
    <Title title='Pacientes' />
    <Grid container spacing={2} size={12}>
      {new Array(3).map((_, index) => (
        <Grid key={'skeleton-patient' + index} size={12}>
          <Box
            sx={{ padding: 2, borderRadius: 1, border: '1px solid #e0e0e0' }}
          >
            <Skeleton variant='text' width='60%' height={24} sx={{ mb: 1 }} />
            <Skeleton variant='text' width='100%' height={16} />
            <Skeleton variant='text' width='100%' height={16} sx={{ mt: 1 }} />
          </Box>
        </Grid>
      ))}
    </Grid>
    <Title title='Médicos' />
    <Grid container spacing={2} size={12}>
      {new Array(3).map((_, index) => (
        <Grid key={'skeleton-doctor' + index} size={12}>
          <Box
            sx={{ padding: 2, borderRadius: 1, border: '1px solid #e0e0e0' }}
          >
            <Skeleton variant='text' width='60%' height={24} sx={{ mb: 1 }} />
            <Skeleton variant='text' width='100%' height={16} />
            <Skeleton variant='text' width='100%' height={16} sx={{ mt: 1 }} />
          </Box>
        </Grid>
      ))}
    </Grid>
    <Title title='Técnico' />
    <Grid container spacing={2} size={12}>
      {new Array(2).map((_, index) => (
        <Grid key={'skeleton-technical' + index} size={12}>
          <Box
            sx={{ padding: 2, borderRadius: 1, border: '1px solid #e0e0e0' }}
          >
            <Skeleton variant='text' width='60%' height={24} sx={{ mb: 1 }} />
            <Skeleton variant='text' width='100%' height={16} />
            <Skeleton variant='text' width='100%' height={16} sx={{ mt: 1 }} />
          </Box>
        </Grid>
      ))}
    </Grid>
  </Grid>
)

export default FAQSkeleton
